import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { ArrowButton } from "@alj-react/ui-components";
import { getComponent, sendToApi } from "../../utils/multi";
import { Context } from "../../utils/ESignatureContext";
import { setIsLoadingSign } from "../../utils/dataFetchers";
import { BottomNavDiv, ArrowButtonStyled } from "./ESignature.styles";

type DisplayPriorConsentProps = {
  apiResult: any;
  messages: any;
  isFormValid: boolean;
  isCancelled: React.MutableRefObject<boolean>;
  isCheckboxOnPage: boolean;
  goToPrevPageBtnTxt?: string,
  goToNextPageBtnTxt?: string,
  goToPrevPage: (e: React.MouseEvent<HTMLElement>) => void;
  goToNextPage: () => Promise<{ success: boolean }>;
  restoreFormInputsToForm: () => void;
  checkFormInputsAndSaveInState: () => Promise<{ success: boolean; data: BizCheckStatus | undefined}>;
};

const DisplayPriorConsent: React.FC<DisplayPriorConsentProps> = (props) => {
  const {
    messages,
    isCancelled,
    isCheckboxOnPage,
    goToPrevPageBtnTxt,
    goToNextPageBtnTxt,
    goToNextPage,
    goToPrevPage,
    restoreFormInputsToForm,
    checkFormInputsAndSaveInState
  } = props;
  const { formatMessage } = useIntl();
  const { dispatch, state } = React.useContext(Context);

  const isExistsElementBytype = (typeName: string): boolean => {
    return document.querySelector(typeName) !== null;
  };

  const isOnePageSubmit = ():boolean => {
    return state.dataToDisplay.Contents?.length === 1 && isExistsElementBytype('form');
  }

  const onPriorConsent =  async () => {

    if (isOnePageSubmit()) {

      const { success } = await checkFormInputsAndSaveInState();

      if (!success) {
        return false;
      }
    } else {
      setIsLoadingSign(dispatch, true);
      sendToApi(state, dispatch, isCancelled, true);
    }
  };

  useEffect(() => {
    if (state.inputResultList.length && isOnePageSubmit()) {
        setIsLoadingSign(dispatch, true);
        sendToApi(state, dispatch, isCancelled, true);
      }
  }, [state.inputResultList]);

  return (
    <>
      {
        state.dataToDisplay?.Contents?.find((content: { pageNo: number, pageContents: any[] }) => content.pageNo === state.currentPageToDisplay)?.pageContents.map(( pageContent: any, subIdx: number) => getComponent(state, dispatch, restoreFormInputsToForm, pageContent, 'page', state.currentPageToDisplay, subIdx, state.inputResultList))
      }
      <BottomNavDiv>
        {
          state.currentPageToDisplay !== 1
            ? <ArrowButtonStyled iconPosition='left' color='white' onClick={goToPrevPage} id='goToPrevPage' data-testid={'goToPrevPage'}>{goToPrevPageBtnTxt || formatMessage(messages.goToPrevPageBtnTxt)}</ArrowButtonStyled>
            : <div></div>
        }
        {
          (state.currentPageToDisplay) === state.dataToDisplay.Contents?.length
            ? <ArrowButton color='orange' disabled={isCheckboxOnPage ? !state.checkboxSelected : false} onClick={onPriorConsent} data-testid={'onPriorConsent'}>{goToNextPageBtnTxt || formatMessage(messages.priorConsentBtnTxt)}</ArrowButton>
            : <ArrowButton onClick={async () => {await goToNextPage();}} disabled={isCheckboxOnPage ? ((!state.checkboxSelected ) || (state.isDoingAuraStuff ? state.auraXmlOutput === '' : false)) : false} style={{ display: (state.isDoingAuraStuff && state.auraXmlOutput === '' ? 'none' : 'inherit') }} data-testid={'goToNextPage'}>{goToNextPageBtnTxt || formatMessage(messages.goToNextPageBtnTxt)}</ArrowButton>
        }
      </BottomNavDiv>
    </>
  );
};

export default DisplayPriorConsent;
